export default {
  isSmallScreen(state) {
    return state.isSmallScreen;
  },

  sideBarWidth(state) {
    return state.sideBarWidth;
  },
};
